import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '../store';
import { getTransactionsHistory } from '../store/actions/transactions-history';
import { RootState } from '../types';
import { TRANSACTION_TYPE } from '../types';

export const useOperationsHistory = (type: TRANSACTION_TYPE) => {
  const dispatch = useAppDispatch();
  const history = useSelector(
    (state: RootState) => state.transactionsHistory.data.history
  );
  const loading = useSelector(
    (state: RootState) => state.transactionsHistory.loading.transactions
  );

  useEffect(() => {
    dispatch(getTransactionsHistory({ type, countItems: 5 }));
  }, []);

  return {
    history: history.map((item) => ({
      sum: item.value,
      date: item.openDate,
    })),
    loading,
  };
};
